import React, { FunctionComponent, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { MobXProviderContext } from 'mobx-react';
import { UserStore } from '../../core/user-store';
import { PageHeaderMenuItemConfig } from './page-header.types';
import { ReactComponent as UserIcon } from '../../assets/icons/user.svg';
import { track, TrackedEvent } from '../../core/analytics';
import './page-header.scss';
import { PAGES_BASE_PATHNAMES } from '../../core/consts';

interface OwnProps {
  config: PageHeaderMenuItemConfig[];
}

type Props = OwnProps;

const PageHeaderMenu: FunctionComponent<Props> = ({ config }) => {
  const { userStore } = useContext(MobXProviderContext);
  const { userData, userOktaGroupsMap } = userStore as UserStore;

  const history = useHistory();
  const location = useLocation();

  React.useEffect(() => {}, [location]);

  if (!config || !config.length) {
    return null;
  }

  return (
    <React.Fragment>
      {config.map((menu_entry) => {
        if (!menu_entry) {
          return null;
        }

        let isVisible: boolean = !!(!menu_entry.needs_auth || (userData && userData.id));

        if (isVisible && menu_entry.needs_groups) {
          isVisible = !menu_entry.needs_groups.find((group) => !userOktaGroupsMap[group]);
        }

        if (isVisible && userData && userData.id && menu_entry.hide_when_authenticated) {
          isVisible = false;
        }

        if (process.env.REACT_APP_IS_STAGED_CONTENT_ONLY === 'true' && menu_entry.non_staged_content) {
          isVisible = false;
        }

        if (!isVisible) {
          return null;
        }

        const hasSubMenu: boolean = !!(menu_entry.sub_menu && menu_entry.sub_menu.length);

        if (!hasSubMenu && !menu_entry.title) {
          return null;
        }

        const pathName = !!(isVisible && !hasSubMenu) ? history.location.pathname : undefined;

        const isActive: boolean = menu_entry.url && menu_entry.url === pathName;

        const isSubmenuActive: boolean =
          !menu_entry.url &&
          !!menu_entry.sub_menu &&
          history.location.pathname.startsWith(PAGES_BASE_PATHNAMES.Catalog) &&
          menu_entry.title === 'API Documentation';

        const menu_class: string =
          (menu_entry.css_classes && menu_entry.css_classes.length ? menu_entry.css_classes.join(' ') : '') +
          (hasSubMenu ? ' has-dropdown' : '') +
          (isActive ? ' is-active' : '') + (isSubmenuActive ? ' is-highlighted' : '');

        const appliedTitle = menu_entry.title[0] === '$' ? userData[menu_entry.title] : menu_entry.title;

        return (
          <li
            key={`${appliedTitle}-${JSON.stringify(menu_entry.sub_menu)}`}
            className={menu_class}
            onClick={() => {
              if (menu_entry.method) {
                track(TrackedEvent.pageHeaderMenuActionItemClicked, { title: menu_entry.title });
                menu_entry.method();
              } else if (menu_entry.url) {
                track(TrackedEvent.pageHeaderMenuLinkItemClicked, { href: menu_entry.url });
                history.push(menu_entry.url);
              }
            }}
          >
            {hasSubMenu ? (
              !appliedTitle ? (
                <React.Fragment>
                  <div className="greeting" style={{ transform: 'translateY(4px)' }}>
                    Hi {userData.$first_name}
                  </div>
                  <div title={appliedTitle} style={{ transform: 'translateY(4px)' }}>
                    <UserIcon />
                  </div>
                  <ul>
                    <PageHeaderMenu config={menu_entry.sub_menu} />
                  </ul>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div>{appliedTitle}</div>
                  <ul>
                    <PageHeaderMenu config={menu_entry.sub_menu} />
                  </ul>
                </React.Fragment>
              )
            ) : (
              <a href={null}>{appliedTitle}{menu_entry.badge ? <div className='badge'>{menu_entry.badge}</div> : null}</a>
            )}
          </li>
        );
      })}
    </React.Fragment>
  );
};

export default PageHeaderMenu;
